import React from 'react';

const Loading = () => (
    <div className="container" style={{ minHeight: '500px', position: 'relative' }}>
        <div className="loading-container">
            <div className="banner">
                LOADING
                <div className="banner-left" />
                <div className="banner-right" />
            </div>
        </div>
    </div>
);

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/components/Loading.js
 **/